<template>
	<div class="newsBox">

		<div class="max-newsBox">
			<div class="newsBox-banner">
				<div class="newsBox-banner-in">
					<div class="newsBox-banner-in-logo"></div>
				</div>
			</div>

			<div class="newsBox-box">

				<div class="newsBox-box-item" v-for="(item,index) in dataArr" :key="index" @click="tapNewsItem(index)">
					<div class="newsBox-box-item-time">{{item.Fdate}}</div>
					<div class="newsBox-box-item-tit">{{item.title}}</div>
					<div class="newsBox-box-item-text">{{item.title1}}</div>
					<div class="newsBox-box-item-xq">查看详情></div>
				</div>

			</div>
			<div class="newsBox-yw">
				<div class="newsBox-yw-in">
					<!-- <div class="newsBox-yw-in-item">下一页</div>
					<div class="newsBox-yw-in-item xyy">上一页</div> -->
				</div>
			</div>
			<div style="clear:both"></div>
			<div style="height:100px"></div>
			<PageBottom />
		</div>
		
		<div class="min-newsBox">
			<!-- <div class="min-newsBox-daohang" @click="tapMinfanhui">
				← 首页
			</div> -->
			
			<div class="min-newsBox-top" @click="tapMinfanhui()">
				<div class="min-caseBox-top-icon"></div>
				新闻资讯
			</div>
			
			<div class="min-home-news-item-box">
				<div class="min-home-news-item" style="margin-bottom: 0.9375rem;" v-for="(item,index) in dataArr" :key="index" @click="tapNewsItem(index)">
					<div class="min-home-news-item-left">
						{{item.Fdate.split('-')[1] + '-' + item.Fdate.split('-')[2]}}
					</div>
					<div class="min-home-news-item-right">
						<div class="min-home-news-item-right-tit">{{item.title}}</div>
						<div class="min-home-news-item-right-text" v-html="item.title1"></div>
					</div>
				</div>
			</div>
			
		</div>
		
		
	</div>
</template>

<script>
	import PageBottom from '@/components/PageBottom.vue'
	export default {
		name: 'Honor',
		components: {
			PageBottom
		},
		data() {
			return {
				dataArr: [],
			}
		},
		mounted() {
			window.pageYOffset = 0;
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0;
			let that = this;

			//获取新闻数据
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/newslist', {
				// 'aa':1
			}).then(function(response) {

				that.dataArr = response.data.data;
				console.log('新闻', that.dataArr);

			}).catch(function(error) {
				console.log(error);
			});
		},
		methods: {
			//移动端点击返回
			tapMinfanhui(){
				this.$router.push({
					path: '/'
				})
				this.$store.commit('tapNavItem', 6);
			},
			
			tapNewsItem(index) {
				// console.log(index)
				//指定跳转的地址
				let item = encodeURIComponent(JSON.stringify(this.dataArr[index])); //编码
				// console.log(item);
				// localStorage.setItem('newsItem',item)
				this.$router.push({
					name: 'NewsDetails',
					params: {
						item: item
					}
				})
				// this.$router.push({
				// 	path: '/news/details'
				// })
			}
		}
	}
</script>

<style>
	.newsBox-banner {
		width: 100%;
		height: 480px;
		background-image: url(../assets/xinwenBg.jpg);
		background-size: 100% 100%;
		margin-bottom: 100px;
		box-sizing: border-box;
	}

	.newsBox-banner-in {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		position: relative;
	}

	.newsBox-banner-in-logo {
		width: 275px;
		height: 70px;
		background-image: url(../assets/xinwenzixunTit.png);
		background-size: 100% 100%;
		position: absolute;
		top: 250px;
		left: 0;
	}

	.newsBox-box {
		width: 1200px;
		height: 640px;
		/* background: pink; */
		margin: 0 auto;
	}

	.newsBox-box-item {
		width: 380px;
		height: 300px;
		background: #ffffff;
		float: left;
		/* display: inline-block; */
		margin-right: 20px;
		margin-bottom: 20px;
		box-sizing: border-box;
		padding: 0 40px;
		box-shadow: 0px 0px 20px #e6e6e8;
		position: relative;
		cursor: pointer;
		transition: all .5s;
	}

	.newsBox-box-item-time {
		width: 100%;
		height: auto;
		font-size: 15px;
		color: #888888;
		padding-top: 40px;
		box-sizing: border-box;
		font-weight: bold;
	}

	.newsBox-box-item-tit {
		width: 100%;
		height: auto;
		font-size: 18px;
		color: #353535;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		padding-top: 20px;
		box-sizing: border-box;
		font-weight: bold;
	}

	.newsBox-box-item-text {
		width: 100%;
		height: auto;
		font-size: 14px;
		line-height: 26px;
		color: #A9A9A9;
		padding-top: 20px;
		box-sizing: border-box;
		font-weight: bold;
		/* 超过2行省略号 */
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}

	.newsBox-box-item-xq {
		width: 100%;
		height: auto;
		position: absolute;
		bottom: 40px;
		left: 0;
		padding: 0 40px;
		box-sizing: border-box;
		font-size: 14px;
		color: #52dedb;
		font-weight: bold;
	}

	.newsBox-box-item:hover .newsBox-box-item-xq {
		color: #ffffff;
	}

	.newsBox-box-item:hover .newsBox-box-item-text {
		color: #ffffff;
	}

	.newsBox-box-item:hover .newsBox-box-item-tit {
		color: #ffffff;
	}

	.newsBox-box-item:hover .newsBox-box-item-time {
		color: #ffffff;
	}

	.newsBox-box-item:hover {
		background: #52dedb;
		transform: translateY(-10px);
	}

	.newsBox-yw {
		width: 100%;
		height: 32px;
		/* background: red; */
	}

	.newsBox-yw-in {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		/* background: pink; */
		line-height: 32px;
		font-size: 14px;
		/* color: #A9A9A9; */
		color: #555555;
	}

	.newsBox-yw-in-item {
		width: 80px;
		height: 100%;
		float: right;
		/* padding-left: 30px; */
		box-sizing: border-box;
		cursor: pointer;
		text-align: center;
		border: 1px solid #E0E0E0;
		box-sizing: border-box;
		margin-right: 20px;
		border-radius: 6px;
	}

	.xyy {
		float: right;
		margin-right: 20px;
		box-sizing: border-box;
		cursor: pointer;
	}
	.min-newsBox{
		display: none;
	}
	@media only screen and (max-width: 1200px) {
		.max-newsBox{
			display: none;
		}
		.min-newsBox{
			display: block;
			box-sizing: border-box;
			background: #f8f8f8;
			height: 100%;
			width: 100%;
		}
		.newsBox{
			background: #f8f8f8;
			height: 100%;
			width: 100%;
			
		}
		.min-newsBox-daohang{
			padding-bottom: 1.25rem;
			box-sizing: border-box;
		}
		.min-newsBox-top{
			width: 100%;
			height: 2.75rem;
			background: #ffffff;
			border-bottom: 0.0625rem solid #ededed;
			box-sizing: border-box;
			position: relative;
			text-align: center;
			font-size: 1.125rem;
			color: #353535;
			line-height: 2.75rem;
		}
		.min-home-news-item-box{
			width: 100%;
			height: calc(100% - 49px - 44px);
			background: #f8f8f8;
			overflow-y: auto;
			padding: 0.625rem;
			padding-bottom: 0;
			box-sizing: border-box;
		}

	}
</style>
